<template>
  <template v-if="fileId != null && !isDisable">
    <jr-button
      v-if="tagView"
      class="tag-btn text-omit file-open-btn align-left"
      type="info"
      @click="downloadFile"
      icon="el-icon-download"
      size="small"
    >
      <span class="file-name">{{ displayFileName }}</span>
    </jr-button>
    <jr-button v-else class="file-open-btn w-100 px text-omit align-left" type="text" @click="downloadFile">
      <span class="file-name">{{ displayFileName }}</span>
    </jr-button>
  </template>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { AxiosResponse } from 'axios'
import { FileDownloadResponse, FileResponse } from '@/api'
import JrButton from '@/components/jr-parts/JrButton.vue'
import { download, getMimeTypeFromBase64 } from '@/services/file'
import { CreateRequest } from '@/requests/fileDownload'
import { FileNameReadRequest } from '@/requests/file'
import { MimeTypes } from '@/constants/enums'

export default defineComponent({
  name: 'JrFileView',
  components: {
    JrButton,
  },
  props: {
    // ファイルID
    fileId: {
      type: Number,
      required: false,
      default: null,
    },
    // タグ風表示にするか
    tagView: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    // disableの設定
    const isDisable = ref<boolean>(false)
    // ファイルデータ
    const base64 = ref<string | null>(null)
    // 表示ファイル名
    const displayFileName = ref<string | null>(null)

    /**
     * ファイル名取得
     */
    const getFileName = async () => {
      const request = new FileNameReadRequest(props.fileId)
      await request.exec()
      if (request.success) {
        const { data } = request.getResponse() as AxiosResponse<FileResponse>
        // 表示名
        displayFileName.value = data.file_name
      } else {
        // 非活性
        isDisable.value = true
      }
    }
    /**
     * ファイルをダウンロードする
     */
    const downloadFile = async () => {
      const fileName = displayFileName.value
      // ファイル名がnullの場合は何もしない
      if (fileName != null) {
        base64.value = await getBinaryFile()
        download(base64.value, fileName, getMimeTypeFromBase64(base64.value))
      }
    }
    /**
     * ファイルバイナリデータ取得
     */
    const getBinaryFile = async (): Promise<string> => {
      const request = new CreateRequest({
        file_id: props.fileId,
      })
      await request.exec()
      if (request.success) {
        const { data } = request.getResponse() as AxiosResponse<FileDownloadResponse>
        const mimeType = data.mime_type === MimeTypes.PDF ? MimeTypes.OCTETSTREAM : data.mime_type
        // ダウンロード用情報
        return 'data:' + mimeType + ';base64,' + data.file
      } else {
        // ここを通ることは基本的にないが戻り値型エラー対応の為記載
        return ''
      }
    }

    // ファイルID変更時にサーバーからファイル名を取得する
    watch(
      () => props.fileId,
      async (fileId: number | null) => {
        if (fileId != null && fileId != -1) {
          getFileName()
        }
      },
      { immediate: true }
    )

    return {
      displayFileName,
      getBinaryFile,
      downloadFile,
      isDisable,
    }
  },
})
</script>

<style lang="scss" scoped>
.tag-btn {
  max-width: 100%;
  text-decoration: underline;
}
</style>
